import script from "./CompanionSync.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionSync.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionSync.vue?vue&type=style&index=0&id=b05e175c&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b05e175c"]])

export default __exports__